import AutoCrawlIcon from '@assets/images/icons/report/auto-crawl.svg?react'
import DiscoverPagesIcon from '@assets/images/icons/report/discover-pages.svg?react'
import SeoSignalsIcon from '@assets/images/icons/report/seo-signals.svg?react'
import SpotIssuesIcon from '@assets/images/icons/report/spot-issues.svg?react'
import type React from 'react'

interface PromoCard {
  description: string
  icon: React.FC
  title: string
}

export const Cards: PromoCard[] = [
  {
    description: 'Build a complete list of pages found on your website.',
    icon: DiscoverPagesIcon,
    title: 'Discover all pages',
  },
  {
    description: 'Review indexed, skipped, and discovered pages.',
    icon: SeoSignalsIcon,
    title: 'Find SEO signals',
  },
  {
    description: 'Detect broken pages, redirects, and crawl warnings.',
    icon: SpotIssuesIcon,
    title: 'Spot Issues',
  },
  {
    description: 'Schedule recurring crawls and track changes over time.',
    icon: AutoCrawlIcon,
    title: 'Auto Crawl',
  },
]
